import { faPlusCircle } from "@fortawesome/pro-regular-svg-icons/faPlusCircle";
import * as React from "react";

import { MprcIconFa, MprcIconFaProps } from "../MprcIconFa";

export const IconAdd: React.FC<Omit<MprcIconFaProps, "icon">> = (props) => {
    return <MprcIconFa {...props} icon={faPlusCircle} />;
};
